module.exports = __webpack_public_path__ + "img/seo_title.a8a490d3.svg";